import { postToServer } from "../utils/postToServer";
import b64toBlob from "b64-to-blob";

export async function encodeAssets(
  assets: { path: string; assetName: string }[],
  type: string
) {
  const updatedAssets: {
    assetName: string;
    path: string;
    data: string;
    hash: string;
  }[] = [];
  const toEncodePromises = assets.map((asset) => {
    const fileExtension = asset.assetName.substr(
      asset.assetName.lastIndexOf(".") + 1
    );
    if (fileExtension === "mp3") {
      return postToServer("encodeAudio", {
        path: encodeURIComponent(asset.path),
        name: asset.assetName,
      });
    }
    return postToServer("encodeImage", {
      path: encodeURIComponent(asset.path),
      name: asset.assetName,
    });
  });
  const res = await Promise.all(toEncodePromises);
  res.forEach((item, i) => {
    if (item.data) {
      updatedAssets[i] = {
        data: item.data,
        hash: item.hash,
        assetName: assets[i].assetName,
        path: assets[i].path,
      };
    } else {
      console.log(item.message);
      alert(item.message);
    }
  });

  const filesToUpload: {
    hash: string;
    name: string;
    blob: Blob;
    data?: string;
    ext: string;
  }[] = [];
  const imageFormatsAbleToConvertToWebP = ["png", "jpg", "jpeg"];
  updatedAssets.forEach((image, i) => {
    const fileExtension = image.path.substr(image.path.lastIndexOf(".") + 1);
    const contentType = `${type}/${fileExtension}`;
    const blob = b64toBlob(image.data, contentType);
    filesToUpload.push({
      name: image.assetName,
      hash: image.hash,
      blob: blob,
      ext: fileExtension,
      ...(imageFormatsAbleToConvertToWebP.includes(fileExtension) && {
        data: `data:${contentType};base64,${image.data}`,
      }),
    });
  });

  const files = filesToUpload.map(({ blob, data, name, ext, hash }) => {
    return {
      data,
      ext,
      hash,
      file: new File([blob], name),
      assetName: name,
    };
  });
  return files;
}
